import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { PlatformApp } from './pages/PlatformApp';
import { isPlatformHost } from './lib/platformApi';
import { consumeImpersonationHandoff, API_BASE } from './lib/api';
// ⚠ ONE import, and the list lives in styles/index.css. It used to be twenty lines here and
// twenty more in preview-main.tsx; they drifted, and a screen was verified against a preview
// that had never loaded its stylesheet.
import './styles/index.css';

// A support-access handoff arrives from the platform console as a URL fragment (#imp=…), because
// localStorage does not cross subdomains. Consume it BEFORE anything renders or reads a token,
// so the tenant app boots already holding the read-only session.
consumeImpersonationHandoff();

// The platform (super-admin) console is a SEPARATE surface, served on admin.<domain>
// (or ?platform locally). It has its own auth, token storage, and routes — never mixed
// with a tenant session.
const Root = isPlatformHost() ? PlatformApp : App;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

// ---------------------------------------------------------------------------
// PWA: register the service worker so Eduvora is installable to the home screen.
//
// Dev is deliberately excluded — a service worker caching a Vite dev bundle is a
// reliable way to spend an afternoon debugging a stale app that isn't stale.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // ⚠ The API origin is passed on the query string because a service worker cannot read
    // import.meta.env, and the web app and the API are on DIFFERENT hosts. The worker needs it to
    // re-register a subscription the browser has silently rotated; a relative /api/ call from the
    // worker would hit Cloudflare Pages and get index.html back.
    const api = encodeURIComponent(API_BASE);
    navigator.serviceWorker.register(`/sw.js${api ? `?api=${api}` : ''}`).catch(() => {
      // Registration failing is not fatal — the app still works, it just won't install.
    });
  });
}
